import Vue from 'vue'
import i18n from '@/i18n'
//时间格式统一
Vue.filter('dateFormatToSecond', (originVal) => {
    if (originVal && originVal != '') {
        var date = new Date();
        // 自动判断秒(10位)还是毫秒(13位)
        let time = Number(originVal);
        if (String(originVal).length < 13) {
            time = time * 1000;
        }
        date.setTime(time);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    }
    else {
        return ''
    }

})
Vue.filter('dateFormatToDay', (originVal) => {
    if (originVal && originVal != '') {
        var date = new Date();
        // 自动判断秒(10位)还是毫秒(13位)
        let time = Number(originVal);
        if (String(originVal).length < 13) {
            time = time * 1000;
        }
        date.setTime(time);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d;
    }
    else {
        return ''
    }

})
//订单状态筛选
Vue.filter('orderStatusFilter', (originVal) => {
    switch (originVal) {
        case '1':
            return i18n.t('filter.filter1')
        case '2':
            return i18n.t('filter.filter2')
        case '0':
            return i18n.t('filter.filter3')
        case '4':
            return i18n.t('filter.filter4')
        case '8':
            return i18n.t('filter.filter5')
        case '12':
            return i18n.t('filter.filter6')
        case '16':
            return i18n.t('filter.filter7')
        case '20':
            return i18n.t('filter.filter8')
        case '24':
            return i18n.t('filter.filter9')
        case '26':
            return i18n.t('filter.filter10')
        case '28':
            return i18n.t('filter.filter11')
        case '32':
            return i18n.t('filter.filter12')
        case '36':
            return i18n.t('filter.filter13')
        case '40':
            return i18n.t('filter.filter14')
        case '44':
            return i18n.t('filter.filter15')
        case '48':
            return i18n.t('filter.filter16')
        case '52':
            return i18n.t('filter.filter17')
        case '56':
            return i18n.t('filter.filter18')
        case '60':
            return i18n.t('filter.filter19')
        case '64':
            return i18n.t('filter.filter20')
        case '68':
            return i18n.t('filter.filter21')
        case '72':
            return i18n.t('filter.filter22')
        case '76':
            return i18n.t('filter.filter23')
        case '80':
            return i18n.t('filter.filter24')
        case '82':
            return i18n.t('filter.filter25')
        case '83':
            return i18n.t('filter.filter26')
        case '84':
            return i18n.t('filter.filter27')
        case '88':
            return i18n.t('filter.filter6')
        case '89':
            return i18n.t('filter.filter29')
        case '3':
            return i18n.t('filter.filter55')
        case '5':
            return i18n.t('filter.filter56')
        default:
            return ''
    }
});
//订单类型筛选
Vue.filter('orderTypeFilter', (originVal) => {
    switch (originVal) {
        case '0':
            return 'FBA';
        case '1':
            return i18n.t('filter.filter30');
        case '2':
            return i18n.t('filter.filter31');
    }
});
//包装意向
Vue.filter('putIntentFilter', (originVal) => {
    switch (originVal) {
        case '0':
            return i18n.t('filter.filter32');
        case '1':
            return i18n.t('filter.filter33');
        case '2':
            return i18n.t('filter.filter34');
        case '3':
            return i18n.t('filter.filter35');
    }
});

//是or 否
Vue.filter('isornotFilter', (originVal) => {
    switch (originVal) {
        case '0':
            return i18n.t('filter.filter36');
        case '1':
            return i18n.t('filter.filter37');
    }
});

//订单类型
Vue.filter('ordertypeFilter', (originVal) => {
    if (originVal == '1') {
        return i18n.t('filter.filter36');
    }
    if (originVal == '2') {
        return 'YFF';
    }
    if (originVal == '0') {
        return 'FBA';
    }
    if (originVal == '3') {
        return 'ZOZO';
    }
    if (originVal == '4') {
        return 'RSL';
    }

});

//检品
Vue.filter('inspectionFilter', (originVal) => {
    switch (originVal) {
        case 'changeLabel':
            return i18n.t('filter.filter38');
        case 'subtractNeck':
            return i18n.t('filter.filter39');
        case 'changeNeck':
            return i18n.t('filter.filter40');
        case 'subtractWash':
            return i18n.t('filter.filter41');
        case 'changeWash':
            return i18n.t('filter.filter42');
        case 'punch':
            return i18n.t('filter.filter43');
        case 'clearFoul':
            return i18n.t('filter.filter44');
        case 'dry':
            return i18n.t('filter.filter45');
        case 'goods1':
            return i18n.t('filter.filter46');
        case 'changeSize':
            return i18n.t('filter.filter47');
        case 'goods2':
            return i18n.t('filter.filter48');
        case 'other':
            return i18n.t('filter.filter49');
    }
});
//盘点状态
Vue.filter('checkStatusFilter', (originVal) => {
    switch (originVal) {
        case '0':
            return i18n.t('filter.filter50');
        case '1':
            return i18n.t('filter.filter51');
        case '2':
            return i18n.t('filter.filter52');
    }
})
//账单类型
Vue.filter('paymentTypeFilter', (originVal) => {
    switch (originVal) {
        case '2':
            return i18n.t('filter.filter53');
        default:
            return i18n.t('filter.filter54');
    }
});
// 空值转--

Vue.filter('empty', (originVal) => {
    return originVal === null || originVal === undefined || originVal === '' ? '--' : originVal
});

Vue.filter('dateFormatToNYR', (originVal) => {
    if (originVal && originVal != '') {
        var date = new Date();
        // 自动判断秒(10位)还是毫秒(13位)
        let time = Number(originVal);
        if (String(originVal).length < 13) {
            time = time * 1000;
        }
        date.setTime(time);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d
    }
    else {
        return ''
    }

})
Vue.filter('dateFormatToSFM', (originVal) => {
    if (originVal && originVal != '') {
        var date = new Date();
        // 自动判断秒(10位)还是毫秒(13位)
        let time = Number(originVal);
        if (String(originVal).length < 13) {
            time = time * 1000;
        }
        date.setTime(time);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return h + ':' + minute + ':' + second;
    }
    else {
        return ''
    }

})
